import {
  FETCH_PAGES_REQUEST,
  FETCH_PAGES_SUCCESS,
  FETCH_PAGES_ERROR,
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_ERROR,
  FETCH_PAGEBYID_REQUEST,
  FETCH_PAGEBYID_SUCCESS,
  FETCH_PAGEBYID_ERROR,
  FETCH_PAGEBYPARENT_REQUEST,
  FETCH_PAGEBYPARENT_SUCCESS,
  FETCH_PAGEBYPARENT_ERROR,
  FETCH_PAGEBYSLUG_REQUEST,
  FETCH_PAGEBYSLUG_SUCCESS,
  FETCH_PAGEBYSLUG_ERROR,
  FETCH_POSTS_REQUEST,
  FETCH_POSTS_SUCCESS,
  FETCH_POSTS_ERROR
} from '../constants';
import axios from 'axios'

const _PRODURL = '/cms/wordpress/wp-json/wp/v2/'
const _DEVURL = 'https://trapinktattoos.com/cms/wordpress/wp-json/wp/v2/'
const _ROOTURL = process.env.NODE_ENV === 'development' ? _DEVURL : _PRODURL

function fetchPages(params, callback) {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_PAGES_REQUEST,
      payload: []
    });

    axios.get(_ROOTURL + `pages`, { params })
      .then(res => {
        dispatch({
          type: FETCH_PAGES_SUCCESS,
          payload: res.data
        });
        if (callback) { callback(); }
      })
      .catch(err => {
        dispatch({ type: FETCH_PAGES_ERROR });
      });
  };
}

function fetchCategories(params, callback) {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_CATEGORIES_REQUEST,
      payload: []
    });

    axios.get(_ROOTURL + `categories`, { params })
      .then(res => {
        dispatch({
          type: FETCH_CATEGORIES_SUCCESS,
          payload: res.data
        });
        if (callback) { callback(); }
      })
      .catch(err => {
        dispatch({ type: FETCH_CATEGORIES_ERROR });
      });
  };
}

function fetchPageById(id, callback) {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_PAGEBYID_REQUEST,
      payload: []
    });

    axios.get(_ROOTURL + `pages/` + id)
      .then(res => {
        dispatch({
          type: FETCH_PAGEBYID_SUCCESS,
          payload: res.data
        });
        if (callback) { callback(); }
      })
      .catch(err => {
        dispatch({ type: FETCH_PAGEBYID_ERROR });
      });
  };
}

function fetchPageByParent(id, callback) {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_PAGEBYPARENT_REQUEST,
      payload: []
    });

    axios.get(_ROOTURL + `pages?parent=` + id)
      .then(res => {
        dispatch({
          type: FETCH_PAGEBYPARENT_SUCCESS,
          payload: res.data
        });
        if (callback) { callback(); }
      })
      .catch(err => {
        dispatch({ type: FETCH_PAGEBYPARENT_ERROR });
      });
  };
}

function fetchPageBySlug(slug, callback) {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_PAGEBYSLUG_REQUEST,
      payload: []
    });

    axios.get(_ROOTURL + `pages?slug=` + slug)
      .then(res => {
        dispatch({
          type: FETCH_PAGEBYSLUG_SUCCESS,
          payload: res.data
        });
        if (callback) { callback(); }
      })
      .catch(err => {
        dispatch({ type: FETCH_PAGEBYSLUG_ERROR });
      });
  };
}

function fetchPosts(params, callback) {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_POSTS_REQUEST,
      payload: []
    });

    axios.get(_ROOTURL + `posts`, { params })
      .then(res => {
        dispatch({
          type: FETCH_POSTS_SUCCESS,
          payload: {
            data: res.data,
            numPages: res.headers['x-wp-totalpages']
          }

        });
        if (callback) { callback(); }
      })
      .catch(err => {
        dispatch({ type: FETCH_POSTS_ERROR });
      });
  }
}

export {
  fetchPages,
  fetchCategories,
  fetchPageById,
  fetchPageByParent,
  fetchPageBySlug,
  fetchPosts
};



// WEBPACK FOOTER //
// ./src/store/actions/index.js